"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nextDetection = exports.fallbackLanguage = void 0;
exports.fallbackLanguage = {
    default: ['zh-CN'],
    en: ['en-US'],
    zh: ['zh-CN'],
    'zh-TW': ['zh-HK'],
    'en-US': ['zh-CN'],
    'zh-HK': ['zh-CN'],
};
exports.i18nextDetection = {
    order: ['querystring', 'userAgent', 'cookie'],
    lookupCookie: 'language',
    caches: [],
};
//# sourceMappingURL=index.js.map